import React from "react";
import { motion } from "framer-motion";
import "./CenteredTitleSection.css";

const CenteredTitleSection = ({ title, subtitle }) => {
  return (
    <section className="center-title-section">

      {/* Title Animation */}
      <motion.h1
        className="center-title-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        {title}
      </motion.h1>

      {/* Subtitle Animation */}
      {subtitle && (
        <motion.p
          className="center-title-subtitle"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          {subtitle}
        </motion.p>
      )}
    </section>
  );
};

export default CenteredTitleSection;
